import { gql } from "@apollo/client";

export const GET_SETTINGS_ONLY = gql`
  query {
    getSettings {
      angelos_show
      time_zone
      hide_achievements
      block_password_change
      block_lang_selection
      hide_quizzes
      allow_retakes
      theme
    }
  }
`;

export const GET_PLANS = gql`
  query {
    plans(all: true) {
      id
      name
      price_amount
      regular_price
      subtitle
      students
      days
    }
    pageSettings(types: ["paypal"]) {
      id
      type
      description
    }
  }
`;

export const GET_LANGUAGES = gql`
  query {
    languages {
      id
      name
      active
      active_creator
      user_active
    }
  }
`;

export const GET_READERS = gql`
  query getBooks($class_id: ID, $reader_type: String) {
    books(lang_id: "auto", class_id: $class_id, reader_type: $reader_type) {
      author {
        id
        name
      }
      id
      is_author
      chapters
      title
      url
      total_ratings
      coming_soon
      is_new
      print_url
      level_id
      video_url
      rank
      rating
      rating_teachers
      user_chapter
      rating_students
      vocab_url
      image_ver
      unique_words
      total_words
      tense
      images {
        cover
        thumb
        poster
      }
      level {
        id
        name
      }
      description_short
      release_date
      language {
        id
        name
      }
      categories {
        id
        name
        buy_text
      }
    }
  }
`;

export const GET_CATEGORIES = gql`
  query get_categories(
    $limit: Int
    $offset: Int
    $category_id: Int
    $active: Boolean
  ) {
    categories(
      lang_id: "auto"
      limit: $limit
      offset: $offset
      category_id: $category_id
      active: $active
    ) {
      id
      name
      active
      is_level
      is_trending
    }
  }
`;

export const INITIAL_FETCH = gql`
  query get_categories(
    $limit: Int
    $offset: Int
    $category_id: Int
    $active: Boolean
    $class_id: ID
    $reader_type: String
  ) {
    notificationsUnread
    categories(
      lang_id: "auto"
      limit: $limit
      offset: $offset
      category_id: $category_id
      active: $active
    ) {
      id
      name
      active
      is_level
      is_trending
    }
    books(
      lang_id: "auto"
      class_id: $class_id
      order: "release_date"
      reader_type: $reader_type
    ) {
      author {
        id
        name
      }
      id
      title
      chapters
      is_author
      url
      total_ratings
      coming_soon
      is_new
      print_url
      vocab_url
      video_url
      level_id
      rank
      rating
      rating_teachers
      rating_students
      image_ver
      has_prereading
      user_chapter
      unique_words
      total_words
      tense
      images {
        cover
        thumb
        poster
      }
      level {
        id
        name
      }
      description_short
      release_date
      language {
        id
        name
      }
      categories {
        id
        name
        buy_text
      }
      nav_colors {
        background
        color
      }
    }
    languages {
      id
      name
      active
      active_creator
      user_active
    }
    getSettings {
      angelos_show
      time_zone
      hide_achievements
      block_password_change
      block_lang_selection
      hide_quizzes
      allow_retakes
      theme
      no_password_login
    }
    classes {
      id
    }
    getContinueReading(lang_id: "auto") {
      id
      chapters
      is_author
      author {
        id
        name
      }
      title
      url
      total_ratings
      coming_soon
      print_url
      level_id
      rank
      rating
      rating_teachers
      user_chapter
      unique_words
      total_words
      tense
      rating_students
      image_ver
      vocab_url
      rating
      images {
        cover
        thumb
        poster
      }
      level {
        id
        name
      }
      description_short
      release_date
      language {
        id
        name
      }
      categories {
        id
        name
        buy_text
      }
    }
    getRecentReading {
      id
      chapters
      is_author
      author {
        id
        name
      }
      title
      url
      total_ratings
      coming_soon
      print_url
      level_id
      rank
      rating
      rating_teachers
      user_chapter
      rating_students
      image_ver
      unique_words
      total_words
      tense
      images {
        cover
        thumb
        poster
      }
      level {
        id
        name
      }
      description_short
      release_date
      language {
        id
        name
      }
      categories {
        id
        name
      }
    }
    getpopups {
      id
      title
      description
      image
      button_text
      button_link
    }
  }
`;
export const REFRECH_FETCH = gql`
  query getRefreshData {
    getSettings {
      hide_achievements
      block_password_change
      block_lang_selection
      hide_quizzes
      allow_retakes
      angelos_show
      time_zone
      theme
    }
  }
`;
